import * as React from "react";

export class Heading extends React.Component<{ title: string, more: string }, {}> {
    render() {
        return (
            <div className="rj-racing-next-races__header">
                <span className="rj-racing-next-races__title">{this.props.title}</span>
                {/* Will be drawn when coupon is finished <a href="#" className="rj-racing-next-races__more">{this.props.more}</a> */}
            </div>
        )
    }
}